import { useState } from 'react';
import { Title, Text, Pagination, OutlineCard, Table } from '@recargas-dominicanas/core/components';
import { TableHeader } from '@recargas-dominicanas/core/components';
import { PageContainer } from '@recargas-dominicanas/core/components';
import { PageToolbar } from '@recargas-dominicanas/core/components';
import { PageContent } from '@recargas-dominicanas/core/components';
import { BusinessItem } from './business-item/business-item.component';
import { useAsyncEffect } from '@recargas-dominicanas/core/utils';
import { OptionButton } from '../../components/option-button/option-button.component';
import { AddBusinessModal } from './add-business-modal/add-business-modal.component';
import { useBusinessListStore } from '../../stores/businessListStore';
import type { IBusiness } from '@recargas-dominicanas/core/types';
import { AddedBusinessModal } from './added-business-modal/added-business-modal.component';
import { style } from './home.module.css';
import { SearchBar } from '../../components/search-bar/search-bar.component';
import { useDebounce } from '@recargas-dominicanas/core/hooks';

export function Home() {

  const { businessPage, fetch } = useBusinessListStore();
  const debounce = useDebounce();
  const [search, setSearch] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [addedBusiness, setAddedBusiness] = useState<IBusiness>();
  const [openAddedModal, setOpenAddedModal] = useState(false);

  useAsyncEffect(async () => {
    await fetch();
  });

  function handleSearchChange(value: string) {

    setSearch(value);
    
    debounce(value, async (value) => {
      await fetch(businessPage.page, businessPage.size, value);
    });
  }

  async function handleFetchBusinessPage(page: number, size: number) {
    await fetch(page, size);
  }

  function handleAddButtonClick() {
    setOpenModal(true);
  }

  function handleCloseModal() {
    setOpenModal(false);
  }

  return (
    <PageContainer className={style.container}>
      <PageToolbar className={style.toolbar}>
        <Title style={style.title} title='Clientes'/>
        <div className={style.options}>
          <SearchBar 
            value={search} 
            onChange={handleSearchChange}/>
          <OptionButton
            icon='add_business'
            title='Agregar negocio'
            onClick={handleAddButtonClick}/>
        </div>
      </PageToolbar>
      <PageContent className={style.content}>
        <OutlineCard className={style.outlineCard}>
          <Table style={style.table}>
            <TableHeader style={style.tableHeader}>
              <Text text='ID'/>
              <Text text='Negocio'/>
              <Text text='Ciudad'/>
              <Text text='Dirección'/>
              <Text text='Balance'/>
              <Text text='Ventas'/>
              <Text text='Beneficio'/>
              <span></span>
            </TableHeader>
            <tbody>
              {
                businessPage.data.map(business => (
                  <BusinessItem 
                    key={business.id}
                    business={business}
                    onArchive={fetch}/>
                ))
              }
            </tbody>
          </Table>
          <Pagination
            title='Transacciones'
            index={businessPage.index}
            pages={businessPage.pages}
            count={businessPage.count}
            size={businessPage.size}
            onChange={handleFetchBusinessPage}/>
        </OutlineCard>
      </PageContent>
      <AddBusinessModal
        open={openModal}
        onAdded={(business) => {
          setAddedBusiness(business);
          setOpenAddedModal(true);
        }}
        onClose={handleCloseModal}/>
      {addedBusiness && 
        <AddedBusinessModal
          open={openAddedModal}
          business={addedBusiness}
          onClose={() => setOpenAddedModal(false)}/>
      }
    </PageContainer>
  );
}
